import axios from "axios";
export function subscribeEmail(email) {
  var formData = new FormData();
  formData.append("subscribe[email]", email);
  formData.append("web_form_registration_source", "Footer Widget");
  return axios.post("/subscribe", formData);
}